export class CalendarDay {
    scheduleCalendarMarketId: number;
    marketId: number;
    calendarDate: Date;
    isWorking: boolean;
    isFixed: boolean;
    holidayName?: string;
}
